import { createFileRoute } from '@tanstack/react-router'
import DocumentosDigitaisModelosPage from '@/pages/dashboard/documentos-digitais-modelos-page'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/documentos-digitais/modelos/',
)({
  component: DocumentosDigitaisModelosPage,
})
